"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const owm_1 = require("../constants/owm");
const yahoo_1 = require("../constants/yahoo");
const convertCode = (name, iconId, night) => {
    switch (name) {
        case 'owm':
            return convertOWMCode(iconId, night);
        case 'yahoo':
            return convertYahooCode(iconId);
        default:
            throw new Error('Invalid name');
    }
};
const convertOWMCode = (iconId, night) => {
    let prefix = 'wi wi-';
    if (night) {
        if (!owm_1.default.night[iconId]) {
            throw new Error('Icon Id does not exist');
        }
        const { icon } = owm_1.default.night[iconId];
        prefix += 'night-';
        return prefix + icon;
    }
    if (!owm_1.default.day[iconId]) {
        throw new Error('Icon Id does not exist');
    }
    const { icon } = owm_1.default.day[iconId];
    prefix = `${prefix}day-`;
    return prefix + icon;
};
const convertYahooCode = (iconId) => {
    const prefix = 'wi wi-';
    if (!yahoo_1.default[iconId]) {
        throw new Error('Icon Id does not exist');
    }
    const { icon } = yahoo_1.default[iconId];
    return prefix + icon;
};
exports.default = convertCode;
